import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import StarIcon from "@mui/icons-material/Star";
import product_img from "../../assets/images/product/Ortho_Latex_A.jpg";
export default function ProductListingPage() {
  // const [products, setProducts] = useState([]);
  // const [loading, setLoading] = useState(true);

  // Filters
  const [selectedMaterial, setSelectedMaterial] = useState("");
  const [selectedFirmness, setSelectedFirmness] = useState("");
  const [selectedThickness, setSelectedThickness] = useState("");
  const [dropdownSort, setDropdownSort] = useState(false);
  const [selectedSort, setSelectedSort] = useState("Popularity");
  const [showSortModal, setShowSortModal] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [activeFilterTab, setActiveFilterTab] = useState("Material");
  const sortRef = useRef(null);

  const sortOptions = [
    "Popularity",
    "Latest",
    "Price: Low to High",
    "Price: High to Low",
  ];
  const [priceRange, setPriceRange] = useState(60000);
  const navigate = useNavigate();
  const materialOptions = ["Latex", "Memory Foam", "Foam", "Coir", "Ortho"];
  const firmnessOptions = ["Soft", "Medium", "Firm"];
  const thicknessOptions = [4, 6, 8, 10, 12];
  // useEffect(() => {
  //   getProducts();
  // }, []);
  const products = [
    {
      category: "Eloris",
      title: "Mellow Soft Series",
      description:
        "Built for those who prefer naturally responsive comfort with balanced support.",
    },
    {
      category: "Eloris",
      title: "Ortho Back Series",
      description:
        "Built for those who prefer naturally responsive comfort with balanced support.",
    },
    {
      category: "Eloris",
      title: "Elite Memory Series",
      description:
        "Built for those who prefer naturally responsive comfort with balanced support.",
    },
    {
      category: "Eloris",
      title: "Alpha Latex Series",
      description:
        "Built for those who prefer naturally responsive comfort with balanced support.",
    },
    {
      category: "Eloris",
      title: "HyLatex Series",
      description:
        "Built for those who prefer naturally responsive comfort with balanced support.",
    },
  ];

  // const getProducts = async () => {
  //   try {
  //     const response = await fetch(
  //       `${process.env.REACT_APP_BASE_URL}/productdetails/allproducts`,
  //     );

  //     const data = await response.json();

  //     const allProducts = data.flatMap((item) => item.products);

  //     const mattressProducts = allProducts.filter((product) => {
  //       const category = product.category?.toLowerCase();

  //       return (
  //         product.subcategory?.toLowerCase() === "mattresses" &&
  //         (category === "eloris" || category === "organiq")
  //       );
  //     });

  //     setProducts(mattressProducts);

  //     console.log(mattressProducts);
  //   } catch (err) {
  //     console.log(err);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const handleReset = () => {
    setSelectedMaterial("");

    setSelectedFirmness("");

    setSelectedThickness("");

    setPriceRange(60000);
  };
  // if (loading) {
  //   return (
  //     <div className="py-32 text-center text-xl font-semibold">
  //       Loading Products...
  //     </div>
  //   );
  // }
  const filteredProducts = products.filter((product) => {
    const variant = product?.variants?.[0];

    const price = variant?.price || 0;

    const materialMatch =
      !selectedMaterial ||
      product.title?.toLowerCase().includes(selectedMaterial.toLowerCase());

    const firmnessMatch =
      !selectedFirmness ||
      product.tagline?.toLowerCase().includes(selectedFirmness.toLowerCase());

    const thicknessMatch =
      !selectedThickness || variant?.thickness === selectedThickness;

    const priceMatch = price <= priceRange;

    return materialMatch && firmnessMatch && thicknessMatch && priceMatch;
  });
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);
  return (
    <section className="bg-[#EEF2FA] md:py-[120px] py-24 relative">
      <div className="max-w-full xl:max-w-[1500px] mx-auto px-5  xl:px-10">
        {/* Main Layout */}

        <div className="grid  lg:grid-cols-12 gap-8">
          {/* ================= LEFT FILTER ================= */}

          <div className="col-span-3 hidden lg:block">
            <div className="bg-white rounded-xl overflow-hidden shadow-sm">
              {/* Header */}

              <div className="flex justify-between items-center px-6 py-5 border-b">
                <h3 className="font-medium font-lexend text-[20px] text-[#313132]">
                  Filters (1)
                </h3>

                <button
                  onClick={handleReset}
                  className="text-[#1f4990] font-normal font-lexend text-[20px]"
                >
                  Reset
                </button>
              </div>

              {/* MATERIAL */}

              <div className="px-6 py-6 border-b">
                <h4 className="font-normal font-lexend text-[20px] mb-5">
                  Materials
                </h4>

                {["Latex", "Ortho", "Foam", "Coir", "Memory Foam"].map(
                  (item) => (
                    <label
                      key={item}
                      className="flex items-center gap-3  mb-2 cursor-pointer"
                    >
                      <input
                        type="radio"
                        checked={selectedMaterial === item}
                        onChange={() => setSelectedMaterial(item)}
                        className="w-4 h-4 accent-[#1f4990] cursor-pointer"
                      />

                      <span className="font-lexend font-light text-[16px] text-[#313132]">
                        {item}
                      </span>
                    </label>
                  ),
                )}
              </div>

              {/* FIRMNESS */}

              <div className="px-6 py-6 border-b">
                <h4 className="font-normal font-lexend text-[20px] mb-5">
                  Firmness
                </h4>

                {["Soft", "Medium", "Hard"].map((item) => (
                  <label
                    key={item}
                    className="flex items-center gap-3 mb-4 cursor-pointer"
                  >
                    <input
                      type="radio"
                      checked={selectedFirmness === item}
                      onChange={() => setSelectedFirmness(item)}
                      className="w-4 h-4 accent-[#1f4990] cursor-pointer"
                    />

                    <span className="font-lexend font-light text-[16px] text-[#313132]">
                      {item}
                    </span>
                  </label>
                ))}
              </div>

              {/* THICKNESS */}

              <div className="px-6 py-6 border-b">
                <h4 className="font-normal font-lexend text-[20px] mb-5">
                  Thickness
                </h4>

                {["4 Inches", "6 Inches", "8 Inches", "12 Inches"].map(
                  (item) => (
                    <label
                      key={item}
                      className="flex items-center gap-3 mb-4 cursor-pointer"
                    >
                      <input
                        type="radio"
                        checked={selectedThickness === item}
                        onChange={() => setSelectedThickness(item)}
                        className="w-4 h-4 accent-[#1f4990] cursor-pointer"
                      />

                      <span className="font-lexend font-light text-[16px] text-[#313132]">
                        {item}
                      </span>
                    </label>
                  ),
                )}
              </div>

              {/* PRICE */}

              <div className="px-6 py-6">
                <h4 className="font-normal font-lexend text-[20px] mb-5">
                  Price Range
                </h4>

                <div className="flex gap-2 mt-3 font-lexend font-light text-[16px] text-[#313132]">
                  <span>₹970</span>-<span>₹{priceRange.toLocaleString()}</span>
                </div>

                <input
                  type="range"
                  min={500}
                  max={60000}
                  step={500}
                  value={priceRange}
                  onChange={(e) => setPriceRange(Number(e.target.value))}
                  className="w-full accent-[#1f4990]"
                />

                <div className="flex justify-between mt-5">
                  <button className="bg-[#1f4990] text-white px-7 py-2 rounded-md font-lexend font-light text-[16px]">
                    Apply
                  </button>

                  <button
                    onClick={handleReset}
                    className="font-lexend font-light text-[16px] text-[#313132]"
                  >
                    Reset
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* ================= RIGHT SIDE ================= */}

          <div className=" lg:col-span-9">
            {/* Heading */}

            <div className="flex  justify-between items-center mb-8">
              <div className="block xl:flex gap-5 items-center">
                <h1 className="font-calsans text-[52px] font-normal text-[#333333] leading-none">
                  Mattress
                </h1>

                <p className="text-[#666] mt-2 text-[15px] xl:text-[20px] font-lexend font-light">
                  ({products.length} Products Available)
                </p>
              </div>

              <div className="relative min-w-fit hidden lg:block" ref={sortRef}>
                <button
                  type="button"
                  onClick={() => setDropdownSort(!dropdownSort)}
                  className="w-full border border-[#1f4990] rounded-lg px-4 py-3 bg-white flex gap-5 justify-between items-center cursor-pointer"
                >
                  <span className="text-[18px] font-lexend">
                    <span className="font-light text-[#555555]">Sort By:</span>{" "}
                    <span className="font-normal text-[#333333]">
                      {selectedSort}
                    </span>
                  </span>

                  <svg
                    className={`w-5 h-5 text-gray-600 transition-transform duration-200 ${
                      dropdownSort ? "rotate-180" : ""
                    }`}
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </button>

                {dropdownSort && (
                  <ul className="absolute z-20 mt-2 w-full bg-white border border-gray-200 rounded-lg shadow-lg">
                    {sortOptions.map((option) => (
                      <li
                        key={option}
                        onClick={() => {
                          setSelectedSort(option);
                          setDropdownSort(false);
                        }}
                        className="px-4 py-3 hover:bg-[#EEF2FA] cursor-pointer font-lexend"
                      >
                        {option}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>

            {/* Product Grid */}

            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8">
              {filteredProducts.map((product) => {
                const variant = product?.variants?.[0];

                const mrp = variant?.price || 0;
                const salePrice = Math.round(mrp * 0.85);

                return (
                  <div
                    key={product._id}
                    className="bg-white rounded-lg overflow-hidden border border-[#E5E5E5] hover:shadow-lg duration-300 flex flex-col h-full"
                  >
                    {/* IMAGE */}

                    <div className="relative cursor-pointer overflow-hidden">
                      <img
                        src={product_img}
                        // src={product.imageurl?.[0]}
                        alt={product.title}
                        className="w-full h-[260px] object-cover hover:scale-105 duration-300"
                      />

                      {/* Best Seller */}

                      <div
                        className="absolute top-0 -left-2 z-10
             bg-[#C7D8FF] text-[#1f4990]
             font-lexend text-[12px]
             px-4 py-2 rounded-l-md"
                      >
                        Best Seller
                        <span
                          className="absolute left-0 -bottom-2
               border-t-[8px]
               border-r-[8px]
               border-t-[#8FB0EB]
               border-r-transparent"
                        />
                      </div>

                      {/* Rating */}

                      <div className="absolute bottom-3 left-3 bg-[#1f4990] text-white rounded flex items-center px-2 py-1 gap-1">
                        <StarIcon
                          sx={{
                            fontSize: 15,
                            color: "#F4E391",
                          }}
                        />

                        <span className="text-[16px] font-lexend font-light">
                          {product.averageRating || "4.5"}
                        </span>
                      </div>

                      {/* Wishlist */}

                      <button className="absolute bottom-3 right-3 bg-white w-10 h-10 rounded-full flex justify-center items-center shadow-md hover:bg-[#1f4990] hover:text-white duration-300">
                        <FavoriteBorderIcon fontSize="small" />
                      </button>
                    </div>

                    {/* DETAILS */}

                    <div className="px-4 pt-4 pb-5 flex flex-col flex-1">
                      <h2 className="font-lexend font-semibold text-[20px] leading-tight text-[#333333]">
                        {product.title}
                      </h2>

                      <p className="font-lexend text-[#777777] font-light text-[14px] leading-[22px] mt-2 min-h-14">
                        {product.tagline || product.description}
                      </p>

                      {/* PRICE */}

                      <div className="flex items-end gap-2 flex-wrap mt-auto pt-4">
                        <h3 className="font-calsans text-[25px] font-normal leading-none text-[#333333]">
                          ₹{/* {salePrice.toLocaleString("en-IN")} */}
                          44,480
                        </h3>

                        <p className="line-through text-[#B5B5B5] font-lexend text-[16px] ">
                          ₹{/* {mrp.toLocaleString("en-IN")} */} MRP ₹59,300
                        </p>

                        <span className="text-[#5F9C4E] font-lexend font-semibold text-[16px]">
                          15% off
                        </span>
                      </div>
                    </div>

                    {/* ADD TO CART */}

                    <button className="mt-auto w-full bg-[#1f4990] hover:bg-[#173A78] text-white h-[58px] font-calsans font-normal text-[18px] duration-300">
                      Add to Cart
                    </button>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Bottom Bar */}
      {showFilterModal && (
        <div className="fixed inset-0 bg-black/40 z-[999] lg:hidden">
          <div className="absolute bottom-0 left-0 right-0 h-[85vh] bg-white rounded-t-3xl flex flex-col">
            {/* Header */}

            <div className="flex justify-between items-center p-5 border-b">
              <h2 className="font-lexend text-2xl font-semibold">Filters</h2>

              <button onClick={() => setShowFilterModal(false)}>✕</button>
            </div>

            {/* Body */}

            <div className="flex flex-1 overflow-hidden font-lexend">
              {/* Left Menu */}

              <div className="w-[35%] bg-[#F6F6F6] border-r">
                {["Material", "Firmness", "Thickness", "Price"].map((tab) => (
                  <button
                    key={tab}
                    onClick={() => setActiveFilterTab(tab)}
                    className={`w-full py-4 px-4 text-left font-lexend border-b transition

      ${
        activeFilterTab === tab
          ? "bg-white border-r-[3px] border-r-[#1f4990] font-semibold text-[#333]"
          : "text-[#666]"
      }`}
                  >
                    {tab}
                  </button>
                ))}
              </div>

              {/* Right */}

              <div className="flex-1 overflow-y-auto p-6">
                {activeFilterTab === "Material" && (
                  <>
                    <h3 className="font-semibold mb-5">Materials</h3>

                    {materialOptions.map((item) => (
                      <label
                        key={item}
                        className="flex items-center gap-3 mb-4"
                      >
                        <input
                          type="radio"
                          checked={selectedMaterial === item}
                          onChange={() => setSelectedMaterial(item)}
                          className="accent-[#1f4990]"
                        />

                        {item}
                      </label>
                    ))}
                  </>
                )}
                {activeFilterTab === "Firmness" && (
                  <>
                    <h3 className="font-semibold mb-5">Firmness</h3>

                    {firmnessOptions.map((item) => (
                      <label
                        key={item}
                        className="flex items-center gap-3 mb-4"
                      >
                        <input
                          type="radio"
                          checked={selectedFirmness === item}
                          onChange={() => setSelectedFirmness(item)}
                          className="accent-[#1f4990]"
                        />

                        {item}
                      </label>
                    ))}
                  </>
                )}
                {activeFilterTab === "Thickness" && (
                  <>
                    <h3 className="font-semibold mb-5">Thickness</h3>

                    {["4 Inches", "6 Inches", "8 Inches", "12 Inches"].map(
                      (item) => (
                        <label
                          key={item}
                          className="flex items-center gap-3 mb-4"
                        >
                          <input
                            type="radio"
                            checked={selectedThickness === item}
                            onChange={() => setSelectedThickness(item)}
                            className="accent-[#1f4990]"
                          />

                          {item}
                        </label>
                      ),
                    )}
                  </>
                )}
                {activeFilterTab === "Price" && (
                  <>
                    <h3 className="font-semibold mb-5">Price Range</h3>

                    <p className="mb-5">
                      ₹970 - ₹{priceRange.toLocaleString()}
                    </p>

                    <input
                      type="range"
                      min={500}
                      max={60000}
                      step={500}
                      value={priceRange}
                      onChange={(e) => setPriceRange(Number(e.target.value))}
                      className="w-full accent-[#1f4990]"
                    />
                  </>
                )}
              </div>
            </div>

            {/* Footer */}

            <div className="grid grid-cols-2 border-t">
              <button
                onClick={handleReset}
                className="font-lexend font-light text-[16px] text-[#313132]"
              >
                Reset
              </button>

              <button
                onClick={() => setShowFilterModal(false)}
                className="py-4   bg-[#1f4990] text-white  font-lexend font-light text-[16px]"
              >
                Apply
              </button>
            </div>
          </div>
        </div>
      )}
      {showSortModal && (
        <div className="fixed inset-0 bg-black/40 z-[999] lg:hidden">
          <div className="absolute bottom-0 left-0 right-0 bg-white rounded-t-3xl">
            <div className="flex justify-between items-center p-5 border-b">
              <h2 className="font-lexend text-2xl font-semibold">Sort By</h2>

              <button onClick={() => setShowSortModal(false)}>✕</button>
            </div>

            {sortOptions.map((item) => (
              <label
                key={item}
                className="flex items-center gap-4 px-6 py-5 border-b"
              >
                <input
                  type="radio"
                  checked={selectedSort === item}
                  onChange={() => {
                    setSelectedSort(item);
                    setShowSortModal(false);
                  }}
                  className="accent-[#1f4990]"
                />

                <span className="font-lexend">{item}</span>
              </label>
            ))}
          </div>
        </div>
      )}
      <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t lg:hidden">
        <div className="grid grid-cols-2">
          <button
            onClick={() => setShowSortModal(true)}
            className="py-4 border-r font-lexend font-medium text-[#1f4990]"
          >
            Sort
          </button>

          <button
            onClick={() => setShowFilterModal(true)}
            className="py-4 font-lexend font-medium text-[#1f4990]"
          >
            Filters
          </button>
        </div>
      </div>
    </section>
  );
}
